import { notification } from 'antd';
import { all, call, put, take, select, fork } from 'redux-saga/effects';
import * as moment from 'moment';
import update from 'immutability-helper';
// import { notifyMessageAction } from 'store/notification/action';
// import { history } from 'store';
import {
  LOAD_ONSITE_BOOKING_SLOT,
  HOLD_ONSITE_BOOKING_SLOT,
  RELEASE_ONSITE_BOOKING_SLOT,
  SAVE_SELECTED_ONSITE_BOOKING_SLOT,
  BOOK_APPOINTMENT,
} from '../type';
import {
  loadOnsiteBookingSlotSuccessAction,
  loadOnsiteBookingSlotErrorAction,
  holdOnsiteBookingSlotSuccessAction,
  holdOnsiteBookingSlotErrorAction,
  releaseOnsiteBookingSlotAction,
  releaseOnsiteBookingSlotSuccessAction,
  releaseOnsiteBookingSlotErrorAction,
  saveOnsiteSelectedBookingSlotSuccessAction,
  saveOnsiteSelectedBookingSlotErrorAction,
  bookAppointmentSuccessAction,
  bookAppointmentErrorAction,
} from '../action';

import { getOnsiteBookingTimeSlot } from 'store/onsite_booking/selector';

import { convertUnixToDateWithTimezone } from 'utils';
import * as Common from 'common/enum/index';

import { eventChannel } from 'redux-saga';
import { onsiteBookingService, bookingService, patientService } from 'services';

function subscribe(socket, onsiteBookingTimeSlot) {
  return new eventChannel(emit => {
    const socketHandler = (topic, message) => {
      let data = JSON.parse(message.toString());
      if (data.holdCalendarIDs && Array.isArray(data.holdCalendarIDs)) {
        data.holdCalendarIDs.forEach(holdId => {
          for (let date in onsiteBookingTimeSlot) {
            onsiteBookingTimeSlot[date].forEach(timeSlot => {
              if (timeSlot.calendarIdList.indexOf(holdId) >= 0) {
                if (!timeSlot.lockID) {
                  timeSlot.lockID = {};
                }
                if (!timeSlot.lockID[holdId]) {
                  timeSlot.lockID[holdId] = 1;
                } else {
                  timeSlot.lockID[holdId] += 1;
                }
                if (timeSlot.lockID[holdId] >= timeSlot.availableBooking) {
                  timeSlot.lockSlot = true;
                }
              }
            });
          }
        });
      }
      if (data.releaseCalendars) {
        for (let uuid in data.releaseCalendars) {
          for (let date in onsiteBookingTimeSlot) {
            for (let i = 0; i < onsiteBookingTimeSlot[date].length; i++) {
              let timeSlot = onsiteBookingTimeSlot[date][i];
              if (!timeSlot.lockID) {
                continue;
              }
              let max = Number.MIN_SAFE_INTEGER;
              let hasReleased = false;
              for (let i = 0; i < timeSlot.calendarIdList.length; i++) {
                let calendarId = timeSlot.calendarIdList[i];
                if (!timeSlot.lockID[calendarId]) {
                  timeSlot.lockID[calendarId] = 0;
                  max = Math.max(max, 0);
                  continue;
                }
                if (data.releaseCalendars[uuid].indexOf(calendarId) >= 0) {
                  timeSlot.lockID[calendarId] -= 1;
                  hasReleased = true;
                }
                max = Math.max(max, 0);
              }
              if (hasReleased && max < timeSlot.availableBooking) {
                timeSlot.lockSlot = false;
              }
            }
          }
        }
      }
      emit({
        bookingData: onsiteBookingTimeSlot,
        realeaseUUID:
          (data.releaseCalendars && Object.keys(data.releaseCalendars)) || [],
      });
    };
    socket.on('message', socketHandler);
    return () => {};
  });
}

function* read(socket, onsiteBookingTimeSlot) {
  const channel = yield call(subscribe, socket, onsiteBookingTimeSlot);
  while (true) {
    let responseChannel = yield take(channel);
    yield put(
      loadOnsiteBookingSlotSuccessAction({
        bookingData: { ...responseChannel.bookingData },
        releaseUUID: responseChannel.realeaseUUID,
      }),
    );
  }
}

function* loadOnsiteBookingSlot() {
  while (1) {
    try {
      const action = yield take(LOAD_ONSITE_BOOKING_SLOT);
      const socket = action.payload.socketClient;
      const bookingSlotData = yield call(
        onsiteBookingService.getOnsiteBookingSlot,
        action.payload,
      );
      yield put(
        loadOnsiteBookingSlotSuccessAction({
          bookingData: bookingSlotData,
          releaseUUID: [],
        }),
      );

      if (socket) {
        const onsiteBookingTimeSlot = yield select(getOnsiteBookingTimeSlot);
        yield fork(read, socket, onsiteBookingTimeSlot.bookingData);
      }
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(loadOnsiteBookingSlotErrorAction(err));
    }
  }
}

function* holdOnsiteBookingSlot() {
  while (1) {
    const action = yield take(HOLD_ONSITE_BOOKING_SLOT);
    try {
      const holdBookingSlotResponse = yield call(
        bookingService.holdBookingSlot,
        action.payload,
      );
      if (holdBookingSlotResponse && holdBookingSlotResponse.success) {
        yield put(holdOnsiteBookingSlotSuccessAction(holdBookingSlotResponse));
      } else {
        if (action.payload.callback) {
          action.payload.callback();
        }
        throw new Error(holdBookingSlotResponse.message);
      }
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(holdOnsiteBookingSlotErrorAction(err));
    }
  }
}

function* releaseOnsiteBookingSlot() {
  while (1) {
    const action = yield take(RELEASE_ONSITE_BOOKING_SLOT);
    try {
      const releaseBookingSlotResponse = yield call(
        bookingService.releaseBookingSlot,
        action.payload,
      );
      yield put(
        releaseOnsiteBookingSlotSuccessAction(releaseBookingSlotResponse),
      );
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(releaseOnsiteBookingSlotErrorAction(err));
    }
  }
}

function* saveOnsiteSelectedBookingSlot() {
  while (1) {
    const action = yield take(SAVE_SELECTED_ONSITE_BOOKING_SLOT);
    try {
      yield put(saveOnsiteSelectedBookingSlotSuccessAction(action.payload));
    } catch (err) {
      yield put(saveOnsiteSelectedBookingSlotErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* bookAppointment() {
  while (1) {
    const action = yield take(BOOK_APPOINTMENT);

    try {
      //Upload signature first before book appointment
      const values = action.payload;
      //Data will be passed to book appointment
      let patient,
        bookingSlot,
        billing,
        token,
        organisationId,
        contact,
        caseId,
        caseName,
        patientId,
        companies,
        isReturnPatient,
        currentHoldingSlot,
        signature = null;

      contact = values.contact;
      patient = values.patient;
      billing = values.billing;
      currentHoldingSlot = values.currentHoldingSlot;
      bookingSlot = values.bookingSlot;
      organisationId = values.organisationId;
      token = values.token;
      patientId = patient.id;
      companies = values.companies;
      isReturnPatient = values.isReturnPatient;

      if (!bookingSlot || Object.keys(bookingSlot).length === 0) {
        throw new Error('Please choose Timeslot');
      }
      if (!isReturnPatient) {
        const createdPatient = yield call(patientService.createPatient, {
          patient,
          contact,
          billing,
          companies,
          organisationId,
        });

        patientId = createdPatient.patient.id;
        patient = createdPatient.patient;
      }

      const sampleCaseData = {
        patientId,
        organisationId,
        caseProblemName: `Onsite Company Online Booking - ONSITE - ${convertUnixToDateWithTimezone(
          bookingSlot.startTime,
          Common.AUS_TIME_ZONE.UTC800.area,
          Common.Format.Date,
        )}`,
        dateInjury: moment(new Date()).toISOString(),
      };
      const caseInfo = yield call(
        patientService.createPatientCase,
        sampleCaseData,
      );

      //Update data to book appointment
      caseId = caseInfo.id;
      caseName = caseInfo.caseProblemName;

      const base64SignatureData = contact.signature;
      const binaryData = new Buffer(
        base64SignatureData.replace(/^data:image\/\w+;base64,/, ''),
        'base64',
      );
      const uploadDataInfo = yield call(onsiteBookingService.getUploadData, {
        fileExtension: 'jpg',
        token,
      });

      const { rawUrl, fileUrl } = uploadDataInfo;
      yield call(onsiteBookingService.uploadSignature, {
        rawUrl,
        data: binaryData,
      });

      signature = fileUrl;

      const updatedValues = update(values, {
        patient: { $set: patient },
        contact: {
          signature: { $set: null },
        },
        patientId: { $set: patientId },
        signature: { $set: signature },
        caseId: { $set: caseId },
        caseName: { $set: caseName },
        organisationId: { $set: organisationId },
      });
      const bookedAppointment = yield call(
        bookingService.bookAppointment,
        updatedValues,
      );

      const callBack = action.payload.callback;
      if (currentHoldingSlot) {
        yield put(
          releaseOnsiteBookingSlotAction({
            uuid: currentHoldingSlot.uuid,
            filter: {
              lockSocket: true,
            },
          }),
        );
      }

      yield put(bookAppointmentSuccessAction(bookedAppointment));

      if (callBack) {
        callBack();
      }
      notification.success({
        message: 'New appointment has been successfully booked',
      });
    } catch (err) {
      notification.error({
        message: err.message || err.toString(),
      });
      yield put(bookAppointmentErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadOnsiteBookingSlot(),
    holdOnsiteBookingSlot(),
    releaseOnsiteBookingSlot(),
    saveOnsiteSelectedBookingSlot(),
    bookAppointment(),
  ]);
}
